import * as Scrivito from "scrivito";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const Image = Scrivito.provideObjClass("Image", {
  attributes: {
    blob: "binary",
    tags: "stringlist",
    alternativeText: "string",
    headline: "string",
    title: "string",
    caption: "html",
    asimUrl: "string",
    pimId: "string",
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
});

export default Image;
